// @ts-nocheck
/** MI DOMINO - admin/portal. */
import { FLAG_LIST, cname } from '../data/catalog';
import { ONLINE_MODE } from '../data/config';
import { saveWallet } from '../economy/tienda';
import { updateCoinBal } from '../economy/wallet';
import { applyLang, L, fireworks, lobbyName, newMatch } from '../game/engine';
import { airhorn, clack } from '../game/sounds';
import { applyProfile, hydrateState, saveAccount, upsertSelfUser } from '../identity/profile';
import { hashPw } from '../identity/hash';
import { askLevel } from '../ui/onboarding';
import { wireSocket } from '../net/table';
import { api } from '../net/api';
import { API_BASE } from '../net/base';
import { ACCOUNT, ADMIN_DB, API_TOKEN, NET, PROFILE, STATS, WALLET, setADMIN_DB, setAPI_TOKEN, setSocket, socket } from '../state';
import { NAMES } from '../data/config';
import { banner } from '../ui/banner';
import { log } from '../ui/feed';
import { LANG, setLang, t } from '../ui/i18n';

/* The wait room replaces the lobby card's contents; leaving a table (cancel
   matchmaking, back out of a lobby) puts the original card back and rewires it. */
let LOBBY_HTML = '';
export function restoreLobby() {
  const m = document.getElementById('lobby-modal');
  if (!m || !LOBBY_HTML) return;
  m.innerHTML = LOBBY_HTML;
  bindLobby();
  applyLang();
  document.getElementById('lobby-bg').classList.add('show');
}

export function initLobby() {
  const online = typeof io !== 'undefined';
  LOBBY_HTML = document.getElementById('lobby-modal').innerHTML;
  if (!online) {
    const sec = document.getElementById('online-sec');
    sec.style.opacity = .35;
    sec.style.pointerEvents = 'none';
    document.getElementById('online-note').textContent = L(
      'Para jugar online: en esta carpeta ejecuta "npm install" y luego "node server.js", y abre http://localhost:3000',
      'To play online: in this folder run "npm install" then "node server.js", and open http://localhost:3000');
    bindLobby();
    return;
  }
  setSocket(io(API_BASE || undefined));
  wireSocket();
  bindLobby();
}

function bindLobby() {
  const bg = document.getElementById('lobby-bg');
  document.getElementById('lobby-solo').onclick = () => askLevel(() => {
    bg.classList.remove('show');
    NET.active = false;
    // a guest who typed a name in the lobby gets it on the seat (not "TÚ"/"YOU")
    const typed = (document.getElementById('lobby-name') as HTMLInputElement).value.trim();
    if (typed && !PROFILE.name) {
      NAMES[0] = typed;
      const n0 = document.getElementById('name0');
      if (n0) n0.textContent = typed;
    }
    newMatch();
  });
  if (!socket) return;
  /* ⚡ Quick match: one tap → the server seats you with whoever is looking
     (same target), and the table starts by itself — no code, no host. */
  const q = document.getElementById('lobby-quick');
  if (q) q.onclick = () => askLevel(() => {
    const name = lobbyName();
    const invite = (window as any).__inviteCode;
    if (invite) {
      // came through an invite link: join THAT table, never a random one
      socket.emit('joinRoom', { code: invite, name, token: API_TOKEN }, res => {
        if (res && res.error) document.getElementById('online-note').textContent = res.error;
        else if (res && res.code) { NET.code = res.code; NET.myName = name; }
      });
      return;
    }
    q.disabled = true;
    q.textContent = LANG === 'en' ? '⚡ Searching…' : '⚡ Buscando…';
    socket.emit('quickMatch',
      { name, target: parseInt(document.getElementById('mode').value, 10), token: API_TOKEN },
      res => {
        if (res && res.error) { document.getElementById('online-note').textContent = res.error; q.disabled = false; applyLang(); }
        else if (res && res.code) { NET.code = res.code; NET.myName = name; }
      });
  });
  document.getElementById('lobby-create').onclick = () => askLevel(() => {
    const name = lobbyName();
    socket.emit('createRoom',
      { name, target: parseInt(document.getElementById('mode').value, 10), token: API_TOKEN },
      res => { if (res && res.code) { NET.code = res.code; NET.myName = name; } });
  });
  document.getElementById('lobby-join').onclick = () => askLevel(() => {
    const name = lobbyName();
    const code = document.getElementById('lobby-code').value;
    socket.emit('joinRoom', { code, name, token: API_TOKEN }, res => {
      if (res && res.error) document.getElementById('online-note').textContent = res.error;
      else if (res && res.code) { NET.code = res.code; NET.myName = name; }
    });
  });
}

/** Fetch + render the server top-10 leaderboard into #lb-panel (Phase 3.2). */
export function loadLeaderboard() {
  const panel = document.getElementById('lb-panel');
  if (!panel) return;
  const esc = s => String(s || L('Jugador', 'Player')).replace(/[<>]/g, '');
  const title = LANG === 'en' ? 'LEADERBOARD — Top 10' : 'CLASIFICACIÓN — Top 10';
  fetch(API_BASE + '/api/leaderboard').then(r => r.json()).then(d => {
    const top = (d && d.top) || [];
    if (!top.length) {
      panel.innerHTML = `<b style="font-size:13px;color:var(--gold)">🏆 ${title}</b>
        <div style="opacity:.6;font-size:12px;margin-top:6px">${LANG === 'en'
          ? 'No games yet — play an online match to appear here.'
          : 'Aún no hay partidas — juega una mesa online para aparecer.'}</div>`;
      return;
    }
    const rows = top.map((u, i) => `<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid rgba(255,255,255,.06)">
        <span style="width:22px;font-weight:800;color:${i < 3 ? 'var(--gold)' : 'inherit'}">${i + 1}</span>
        <b style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${esc(u.apodo)}</b>
        <span style="opacity:.8">${u.wins}<small style="opacity:.55">/${u.games}</small></span>
        <span style="color:var(--gold);font-weight:700;min-width:60px;text-align:right">${u.points} 🪙</span>
      </div>`).join('');
    panel.innerHTML = `<b style="font-size:13px;color:var(--gold)">🏆 ${title}</b>
      <div style="display:flex;gap:8px;font-size:10px;opacity:.5;margin:6px 0 2px">
        <span style="width:22px">#</span><span style="flex:1">${LANG === 'en' ? 'PLAYER' : 'JUGADOR'}</span>
        <span>${LANG === 'en' ? 'W/G' : 'G/P'}</span>
        <span style="min-width:60px;text-align:right">${LANG === 'en' ? 'POINTS' : 'PUNTOS'}</span>
      </div>${rows}`;
  }).catch(() => {
    panel.innerHTML = `<b style="color:var(--gold)">🏆 ${title}</b>
      <div style="opacity:.6;font-size:12px">${LANG === 'en' ? 'Unavailable' : 'No disponible'}</div>`;
  });
}

export function seedAdminDB() {
  const now = Date.now(), day = 864e5;
  const demoUsers = [
    ['María Peralta', 'maria.p@gmail.com', '🇩🇴', 4, 'mensual', 23.98],
    ['Carlos Jiménez', 'cjimenez88@hotmail.com', '🇵🇷', 6, 'anual', 148.99],
    ['Yubelkis Santos', 'yubelkis.s@yahoo.com', '🇩🇴', 3, null, 4.99],
    ['Papo Reyes', 'paporeyes@gmail.com', '🇺🇸', 7, 'anual', 218.97],
    ['Doña Carmen', 'carmenlavieja@gmail.com', '🇩🇴', 2, null, 0],
    ['Junior Vargas', 'jrvargas21@gmail.com', '🇨🇴', 5, 'mensual', 35.97],
    ['Yesenia Cruz', 'yesi.cruz@outlook.com', '🇵🇷', 4, 'mensual', 11.99],
    ['Wilson Núñez', 'wnunez@gmail.com', '🇩🇴', 8, 'anual', 318.96],
    ['La Vecina', 'vecina.chismosa@gmail.com', '🇻🇪', 1, null, 0],
    ['Compa Luis', 'luisito.rd@gmail.com', '🇲🇽', 5, 'mensual', 61.96],
    ['Rafelito', 'rafelito.pro@gmail.com', '🇩🇴', 9, 'anual', 417.94],
    ['El Músico', 'trompeta.fuego@gmail.com', '🇨🇺', 3, null, 9.99],
  ].map((u, i) => ({ name: u[0], email: u[1], country: u[2], rank: u[3], pro: u[4], spend: u[5], joined: now - (i * 3 + 2) * day, demo: true }));
  const demoCards = [['Visa', '4242', '08/27'], ['Mastercard', '5511', '03/28'], ['Visa', '9187', '01/28'], ['Amex', '0005', '11/26'], ['Discover', '6011', '05/27']];
  demoUsers.forEach((u, i) => {
    u.phone = u.spend > 0 ? `+1 809 555 0${String(100 + i).slice(-3)}` : '';
    if (u.spend > 0) {
      u.pay = i % 4 === 0
        ? { type: 'crypto', coin: 'USDC', wallet: '0x7a3F…c9' + (20 + i) }
        : { type: 'card', brand: demoCards[i % demoCards.length][0], last4: demoCards[i % demoCards.length][1], exp: demoCards[i % demoCards.length][2] };
    }
  });
  const items = [['Bolsa de Puntos', 9.99], ['PRO CLUB Mensual', 11.99], ['Cofre de Puntos', 19.99], ['PRO CLUB Anual', 99], ['Puñado de Puntos', 4.99], ['Sobre premium', 4.99]];
  const sales = [];
  for (let i = 0; i < 14; i++) {
    const u = demoUsers[i % demoUsers.length], it = items[i % items.length];
    sales.push({ item: it[0], usd: it[1], method: i % 3 ? 'card' : 'crypto:USDC', pay: u.pay || null, buyer: u.name, email: u.email, ts: now - Math.round(i * 0.8 * day), demo: true });
  }
  return { users: demoUsers, sales };
}

export function saveAdminDB() { try { localStorage.setItem('admindb', JSON.stringify(ADMIN_DB)); } catch (e) {} }

/** Seed / migrate the Founder's local ledger (demo rows refresh, real rows survive). */
export function initAdminDB() {
  if (!ADMIN_DB || !ADMIN_DB.users || ADMIN_DB.v !== 2) {
    const fresh = seedAdminDB();
    fresh.v = 2;
    if (ADMIN_DB && ADMIN_DB.users) { /* keep real users/sales, refresh demo rows */
      fresh.users = [...ADMIN_DB.users.filter(u => !u.demo), ...fresh.users];
      fresh.sales = [...ADMIN_DB.sales.filter(s => !s.demo), ...fresh.sales];
    }
    setADMIN_DB(fresh);
    try { localStorage.setItem('admindb', JSON.stringify(ADMIN_DB)); } catch (e) {}
  }
}

export function exportCSV(rows, name) {
  const csv = rows.map(r => r.map(x => '"' + String(x).replace(/"/g, '""') + '"').join(',')).join('\n');
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob(['﻿' + csv], { type: 'text/csv' }));
  a.download = name;
  a.click();
}

export function exportAdminCSV(which) {
  if (which === 'users') {
    exportCSV([['name', 'email', 'country', 'rank', 'plan', 'spend_usd', 'joined', 'source'],
      ...ADMIN_DB.users.map(u => [u.name, u.email, u.country, u.rank, u.pro || 'free', (u.spend || 0).toFixed(2), new Date(u.joined).toISOString().slice(0, 10), u.demo ? 'demo' : 'real'])], 'mi-domino-users.csv');
  } else {
    exportCSV([['date', 'item', 'buyer', 'email', 'method', 'usd', 'source'],
      ...ADMIN_DB.sales.map(s => [new Date(s.ts).toISOString().slice(0, 10), s.item, s.buyer, s.email, s.method, s.usd.toFixed(2), s.demo ? 'demo' : 'real'])], 'mi-domino-sales.csv');
  }
}

export function setToken(t) {
  setAPI_TOKEN(t || '');
  try { t ? localStorage.setItem('mdtoken', t) : localStorage.removeItem('mdtoken'); } catch (e) {}
}

/** A server session (login / password reset) becomes THIS device's account:
 *  token, the account record (server decides who the founder is), and the
 *  player's whole life pulled down. Guest → account: whatever this device
 *  earned or bought as a guest (coins, domino sets, collectibles, stats) joins
 *  the account instead of being thrown away. The server adds coins/stats only
 *  the FIRST time (state.guest_merged); afterwards purchases are still kept but
 *  paid with the account's coins — so nothing is lost and nothing is farmed. */
export async function adoptSession(res) {
  setToken(res.token);
  ACCOUNT.fullname = res.user.fullname;
  ACCOUNT.email = res.user.email;
  ACCOUNT.phone = res.user.phone || '';
  ACCOUNT.dob = res.user.dob || '';
  ACCOUNT.optin = !!res.user.optin;
  ACCOUNT.joined = new Date(res.user.created_at || Date.now()).getTime();
  ACCOUNT.founder = !!res.user.founder;   // server decides who the founder is
  try { localStorage.setItem('account', JSON.stringify(ACCOUNT)); } catch (e) {}
  let st = res.state || {};
  const guestProgress = (WALLET.owned && WALLET.owned.length) || (WALLET.collect && WALLET.collect.length)
    || (STATS.hands > 0) || (WALLET.coins !== 500);
  if (guestProgress) {
    try {
      const m = await api('/api/merge-guest', { wallet: WALLET, stats: STATS });
      if (m && m.state) st = m.state;
      if (m && m.merged) try { sessionStorage.setItem('mdmerged', (m.charged && m.charged.length) ? 'charged' : '1'); } catch (e) {}
      if (m && m.dropped && m.dropped.length) try { sessionStorage.setItem('mddropped', String(m.dropped.length)); } catch (e) {}
    } catch (e) { /* offline merge failure: server state still wins below */ }
  }
  hydrateState(st);
}

/** Password recovery — one clean modal: email → send code → code + new password.
 *  (The 6-digit code reaches the player via email/support; the server never
 *  returns it in production.) Replaces the old triple pop-up chains. */
export function showForgotModal() {
  const en = LANG === 'en';
  const ov = document.createElement('div');
  ov.id = 'forgot-ov';
  ov.className = 'royal-door';
  ov.style.cssText = 'position:fixed;inset:0;z-index:9600;background:rgba(6,10,20,.86);display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML = `
    <div style="background:linear-gradient(180deg,#16233d,#101b30);border:1.5px solid #f0b429;border-radius:16px;padding:20px;max-width:340px;width:100%;color:#eaf0fa;box-shadow:0 24px 60px -20px rgba(0,0,0,.9)">
      <h3 style="color:#f0b429;margin:0 0 4px;font-size:20px">${en ? 'Reset password' : 'Restablecer contraseña'}</h3>
      <p style="font-size:12.5px;opacity:.8;margin:0 0 12px">${en ? 'Enter your account email to get a 6-digit code.' : 'Escribe el email de tu cuenta para recibir un código de 6 dígitos.'}</p>
      <input id="fg-email" type="email" placeholder="${en ? 'Account email' : 'Email de la cuenta'}" style="width:100%;margin-bottom:8px">
      <div id="fg-step2" style="display:none">
        <input id="fg-code" placeholder="${en ? '6-digit code' : 'Código de 6 dígitos'}" inputmode="numeric" maxlength="6" style="width:100%;margin-bottom:8px;letter-spacing:4px;text-align:center">
        <input id="fg-pw" type="password" placeholder="${en ? 'New password (6+ chars)' : 'Nueva contraseña (6+ caracteres)'}" style="width:100%;margin-bottom:8px">
      </div>
      <p id="fg-msg" style="font-size:12px;min-height:16px;margin:0 0 8px"></p>
      <button id="fg-go" class="btn gold" style="width:100%">${en ? 'Send code' : 'Enviar código'}</button>
      <button id="fg-cancel" class="btn" style="width:100%;margin-top:6px;background:#33415c">${en ? 'Cancel' : 'Cancelar'}</button>
    </div>`;
  document.body.appendChild(ov);
  const $ = id => ov.querySelector('#' + id);
  const msg = $('fg-msg');
  let sent = false;
  const fail = (m) => { msg.style.color = '#f0a3a3'; msg.textContent = m; };
  $('fg-cancel').onclick = () => ov.remove();
  ov.onclick = (e) => { if (e.target === ov) ov.remove(); };
  $('fg-go').onclick = async () => {
    const email = $('fg-email').value.trim().toLowerCase();
    if (!/.+@.+\..+/.test(email)) return fail(en ? 'Enter a valid email' : 'Escribe un email válido');
    if (!sent) {
      try {
        const r = await api('/api/forgot', { email });
        sent = true;
        $('fg-step2').style.display = 'block';
        $('fg-email').readOnly = true;
        $('fg-code').focus();
        msg.style.color = '#7ee0a8';
        // the server says whether an email actually went out; without a mail
        // provider the code waits in the founder's Admin panel for support to hand over
        msg.textContent = r && r.sent
          ? (en ? 'Code sent — check your inbox (and spam). Valid 30 min.' : 'Código enviado — revisa tu correo (y spam). Vale 30 min.')
          : (en ? 'Code generated — ask MI DOMINO support for it and type it here. Valid 30 min.' : 'Código generado — pídelo a soporte de MI DOMINO y escríbelo aquí. Vale 30 min.');
        $('fg-go').textContent = en ? 'Reset password' : 'Cambiar contraseña';
      } catch (ex) { fail((ex && ex.message) || 'Error'); }
      return;
    }
    const code = $('fg-code').value.trim(), pw = $('fg-pw').value;
    if (!/^\d{6}$/.test(code)) return fail(en ? 'Enter the 6-digit code' : 'Escribe el código de 6 dígitos');
    if (pw.length < 6) return fail(en ? 'Password: 6+ characters' : 'Contraseña: 6+ caracteres');
    try {
      const res = await api('/api/reset', { email, code, pw });
      await adoptSession(res);   // signed in on this device, same as a login (no second door)
      location.reload();
    } catch (ex) { fail((ex && ex.message) || 'Error'); }
  };
}

export function renderEnroll(mode) {
  mode = 'login'; // one door for everyone: name + email + 6-digit code
  const en = LANG === 'en';
  const old = document.getElementById('enroll-ov');
  if (old) old.remove();
  const ov = document.createElement('div');
  ov.id = 'enroll-ov';
  ov.className = 'royal-door';
  ov.style.cssText = "position:fixed;inset:0;z-index:9500;background:linear-gradient(rgba(8,12,26,.82),rgba(8,12,26,.9)),url('/logo.png') center center / cover no-repeat;display:flex;align-items:flex-start;justify-content:center;overflow:auto;padding:16px 16px 28px";
  const F = (label, id, ph, type, extra) => `
    <label style="font-size:11.5px;opacity:.8;display:block;margin:9px 0 3px">${label}</label>
    <input id="${id}" type="${type || 'text'}" placeholder="${ph || ''}" ${extra || ''} style="width:100%;box-sizing:border-box;background:rgba(8,30,16,.75);border:1px solid rgba(240,180,41,.3);border-radius:9px;color:#fff;padding:10px 12px;font-size:14px">`;
  ov.innerHTML = `<div style="width:min(440px,94vw);text-align:center">
    <img src="/logo.png" alt="MI DOMINÓ" style="display:block;width:min(260px,70vw);height:auto;margin:0 auto 8px;border-radius:14px;filter:drop-shadow(0 0 18px rgba(240,180,41,.45))">
    <h1 style="color:var(--gold,#f0b429);margin:4px 0 2px;font-size:34px;letter-spacing:3px">MI DOMINO</h1>
    <p style="opacity:.75;margin:0 0 16px;font-size:13.5px">${en ? 'The table is set. Video, rivals, glory — pull up a chair.' : 'La mesa está servida. Video, rivales, gloria — acerca tu silla.'}</p>
    <div style="background:linear-gradient(180deg,rgba(29,72,36,.94),rgba(12,38,20,.97));border:1.5px solid #f0b429;border-radius:16px;padding:20px 22px;text-align:left;box-shadow:0 0 28px rgba(240,180,41,.25)">
      ${mode === 'signup' ? `
        <div style="background:rgba(240,180,41,.1);border:1px dashed var(--gold,#f0b429);border-radius:9px;padding:7px 10px;font-size:12px;text-align:center;margin:8px 0 2px">
          🎁 ${en ? 'Welcome gift: <b>100 PhilCoins</b> when you join' : 'Regalo de bienvenida: <b>100 PhilCoins</b> al entrar'}
        </div>
        ${F(en ? 'Full name *' : 'Nombre completo *', 'en-name', 'Juan Pérez')}
        ${F(en ? 'Player name (what the table sees) *' : 'Apodo de jugador (lo que ve la mesa) *', 'en-apodo', en ? 'The Pro' : 'El Matatán', 'text', 'maxlength="14"')}
        ${F('Email *', 'en-email', 'tu@email.com', 'email')}
        ${F(en ? 'Phone (optional)' : 'Teléfono (opcional)', 'en-phone', '+1 …', 'tel')}
        <label style="font-size:11.5px;opacity:.8;display:block;margin:9px 0 3px">${en ? 'Country *' : 'País *'}</label>
        <select id="en-country" style="width:100%;background:rgba(8,30,16,.75);border:1px solid rgba(240,180,41,.3);border-radius:9px;color:#fff;padding:10px 12px;font-size:14px">
          ${FLAG_LIST.map(f => `<option value="${f[2]}" ${PROFILE.country === f[2] ? 'selected' : ''}>${f[2]} ${cname(f[1])}</option>`).join('')}
        </select>
        ${F(en ? 'Date of birth *' : 'Fecha de nacimiento *', 'en-dob', '', 'date')}
        ${F(en ? 'Password *' : 'Contraseña *', 'en-pw', '••••••••', 'password', 'minlength="6"')}
        <label style="display:flex;gap:8px;align-items:flex-start;font-size:11.5px;opacity:.85;margin:12px 0 0;cursor:pointer">
          <input type="checkbox" id="en-terms" style="margin-top:2px">
          <span>${en
            ? 'I accept the <a href="/terms" target="_blank" style="color:var(--gold);text-decoration:underline">Terms</a> &amp; <a href="/privacy" target="_blank" style="color:var(--gold);text-decoration:underline">Privacy Policy</a> and I understand MI DOMINO stores my name, email, phone and country to run my account and purchases. *'
            : 'Acepto los <a href="/terms" target="_blank" style="color:var(--gold);text-decoration:underline">Términos</a> y la <a href="/privacy" target="_blank" style="color:var(--gold);text-decoration:underline">Política de Privacidad</a>, y entiendo que MI DOMINO guarda mi nombre, email, teléfono y país para operar mi cuenta y mis compras. *'}</span>
        </label>
        <label style="display:flex;gap:8px;align-items:flex-start;font-size:11.5px;opacity:.7;margin:8px 0 0;cursor:pointer">
          <input type="checkbox" id="en-optin" checked style="margin-top:2px">
          <span>${en ? 'Send me tournaments, drops & news' : 'Envíenme torneos, drops y noticias'}</span>
        </label>
        <button class="btn gold" id="en-go" style="width:100%;margin-top:16px;font-size:16px">👤 ${en ? 'TAKE MY SEAT' : 'OCUPAR MI SILLA'}</button>
      ` : `
        <div id="qs-step1">
          ${F(en ? 'Your name' : 'Tu nombre', 'en-li-name', en ? 'The Pro' : 'El Matatán', 'text', 'maxlength="18"')}
          ${F('Email', 'en-li-email', 'tu@email.com', 'email')}
        </div>
        <div id="qs-step2" style="display:none">
          <p style="font-size:12.5px;opacity:.8;margin:8px 0 0">${en ? 'We emailed you a 6-digit code. Check your inbox and spam.' : 'Te enviamos un código de 6 dígitos. Revisa tu correo y spam.'}</p>
          ${F(en ? '6-digit code' : 'Código de 6 dígitos', 'en-li-code', '', 'text', 'inputmode="numeric" maxlength="6"')}
        </div>
        <button class="btn gold" id="en-li-go" style="width:100%;margin-top:16px;font-size:16px">${en ? 'SEND CODE' : 'ENVIAR CÓDIGO'}</button>
      `}
      <p id="en-err" style="color:#e05555;font-size:12px;min-height:15px;margin:8px 0 0;text-align:center"></p>
      <p style="text-align:center;margin:6px 0 0"><a href="#" id="en-guest" style="color:#66719c;font-size:12px">${en ? 'Just looking — try as guest' : 'Solo mirando — probar como invitado'}</a></p>
    </div>
    <p style="opacity:.45;font-size:11px;margin-top:12px">🎥 ${en ? 'Live video dominos · ranks · collectibles · EL MERCADO' : 'Dominó con video en vivo · rangos · coleccionables · EL MERCADO'}</p>
  </div>`;
  document.body.appendChild(ov);
  // Language switcher on the start screen — flips ES/EN and re-renders the form
  // in place (and the rest of the UI behind it) so everything translates live.
  const langBtn = document.createElement('button');
  langBtn.id = 'en-lang';
  langBtn.className = 'btn';
  // in-flow, right-aligned ABOVE the title — never overlaps it on narrow phones
  langBtn.style.cssText = 'display:block;width:auto;margin:0 0 8px auto;padding:7px 14px;background:#0f6e56;font-size:13px';
  langBtn.textContent = LANG === 'es' ? '🌐 ENGLISH' : '🌐 ESPAÑOL';
  langBtn.onclick = () => { setLang(LANG === 'es' ? 'en' : 'es'); applyLang(); renderEnroll(mode); };
  const inner = ov.firstElementChild;
  if (inner) inner.insertBefore(langBtn, inner.firstChild); else ov.appendChild(langBtn);
  const $e = id => ov.querySelector('#' + id);
  // Enter in any field submits the door (it's not a <form>, so wire it)
  const goBtn = () => $e(mode === 'signup' ? 'en-go' : 'en-li-go');
  for (const inp of ov.querySelectorAll('input')) {
    inp.addEventListener('keydown', ev => { if (ev.key === 'Enter') { ev.preventDefault(); goBtn()?.click(); } });
  }
  // 👁 show/hide password (typos are the #1 "wrong password")
  for (const pwId of ['en-pw', 'en-li-pw']) {
    const pwInp = $e(pwId);
    if (!pwInp) continue;
    const eye = document.createElement('button');
    eye.type = 'button';
    eye.className = 'pw-eye';
    eye.title = en ? 'Show / hide password' : 'Mostrar / ocultar contraseña';
    eye.textContent = '👁';
    eye.onclick = () => { pwInp.type = pwInp.type === 'password' ? 'text' : 'password'; eye.style.opacity = pwInp.type === 'password' ? '' : '1'; };
    const wrap = document.createElement('div');
    wrap.className = 'pw-wrap';
    pwInp.parentNode.insertBefore(wrap, pwInp);
    wrap.appendChild(pwInp);
    wrap.appendChild(eye);
  }
  // guest = a choice made here, every launch (the door comes back on reload)
  $e('en-guest').onclick = ev => { ev.preventDefault(); try { sessionStorage.setItem('guest', '1'); } catch (e) {} ov.remove(); };
  if (mode === 'signup') {
    $e('en-go').onclick = async () => {
      const err = $e('en-err');
      const name = $e('en-name').value.trim(), apodo = $e('en-apodo').value.trim(), email = $e('en-email').value.trim().toLowerCase();
      const phone = $e('en-phone').value.trim(), country = $e('en-country').value, dob = $e('en-dob').value, pw = $e('en-pw').value;
      if (!name || !apodo || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = LANG === 'en' ? 'Name, player name and a valid email are required.' : 'Nombre, apodo y un email válido son requeridos.'; return; }
      if (!dob) { err.textContent = LANG === 'en' ? 'Date of birth is required.' : 'La fecha de nacimiento es requerida.'; return; }
      const age = (Date.now() - new Date(dob).getTime()) / 3.15576e10;
      if (age < 13) { err.textContent = LANG === 'en' ? 'You must be 13 or older to play MI DOMINO.' : 'Debes tener 13 años o más para jugar MI DOMINO.'; return; }
      if (pw.length < 6) { err.textContent = LANG === 'en' ? 'Password: 6+ characters.' : 'Contraseña: 6+ caracteres.'; return; }
      if (!$e('en-terms').checked) { err.textContent = LANG === 'en' ? 'You must accept the Terms to play.' : 'Debes aceptar los Términos para jugar.'; return; }
      /* ONLINE: create the account on the server (one login, every device) */
      if (ONLINE_MODE) {
        try {
          $e('en-go').textContent = LANG === 'en' ? 'CREATING…' : 'CREANDO…';
          const res = await api('/api/signup', {
            fullname: name, apodo, email, phone, country, dob, pw,
            optin: $e('en-optin').checked,
          });
          setToken(res.token);
          ACCOUNT.founder = !!(res.user && res.user.founder);
        } catch (ex) {
          $e('en-go').textContent = LANG === 'en' ? '👤 TAKE MY SEAT' : '👤 OCUPAR MI SILLA';
          err.textContent = ex.message;
          return;
        }
      }
      ACCOUNT.fullname = name;
      ACCOUNT.email = email;
      ACCOUNT.phone = phone;
      ACCOUNT.dob = dob;
      ACCOUNT.optin = $e('en-optin').checked;
      ACCOUNT.pwh = await hashPw(pw);
      ACCOUNT.joined = Date.now();
      saveAccount();
      PROFILE.name = apodo;
      PROFILE.country = country;
      try { localStorage.setItem('profile', JSON.stringify(PROFILE)); } catch (e) {}
      WALLET.coins += 100;
      saveWallet();
      upsertSelfUser();
      applyProfile();
      updateCoinBal();
      applyLang();   // refresh the sidebar account label with the new apodo (menu was built before signup)
      ov.remove();
      airhorn();
      fireworks();
      banner(LANG === 'en' ? `🎉 WELCOME, ${apodo.toUpperCase()}! +100 🪙` : `🎉 ¡BIENVENIDO, ${apodo.toUpperCase()}! +100 🪙`);
      log(LANG === 'en' ? `👤 ${apodo} joined MI DOMINO — welcome gift +100 🪙` : `👤 ${apodo} se unió a MI DOMINO — regalo de bienvenida +100 🪙`, true);
    };
  } else {
    // Forgot password (v1): 6-digit code via /api/forgot + /api/reset.
    const fgA = document.createElement('a');
    fgA.href = '#';
    fgA.style.cssText = 'display:block;text-align:center;margin:8px 0 0;color:#f0b429;font-size:12px';
    fgA.textContent = LANG === 'en' ? 'Forgot your password?' : '¿Olvidaste tu contraseña?';
    const fgBtn = $e('en-li-go');
    if (fgBtn && fgBtn.parentElement) fgBtn.parentElement.appendChild(fgA);
    fgA.onclick = (ev) => { ev.preventDefault(); showForgotModal(); };
    let qsStep = 1;
    const qsErr = (m, ok) => { const e = $e('en-err'); e.style.color = ok ? '#7ee0a8' : '#e05555'; e.textContent = m; };
    $e('en-li-go').onclick = async () => {
      if (!ONLINE_MODE) return qsErr(LANG === 'en' ? 'Sign-in needs the online server.' : 'Entrar requiere el servidor en línea.');
      const name = $e('en-li-name').value.trim();
      const email = $e('en-li-email').value.trim().toLowerCase();
      const btn = $e('en-li-go');
      const label = qsStep === 1 ? (LANG === 'en' ? 'SEND CODE' : 'ENVIAR CÓDIGO') : (LANG === 'en' ? 'ENTER THE TABLE' : 'ENTRAR A LA MESA');
      if (qsStep === 1) {
        if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return qsErr(LANG === 'en' ? 'Enter your name and a valid email.' : 'Escribe tu nombre y un email válido.');
        try {
          btn.textContent = LANG === 'en' ? 'SENDING…' : 'ENVIANDO…';
          await api('/api/quick/start', { name, email });
          qsStep = 2;
          $e('qs-step1').style.display = 'none';
          $e('qs-step2').style.display = 'block';
          $e('en-li-code').focus();
          btn.textContent = LANG === 'en' ? 'ENTER THE TABLE' : 'ENTRAR A LA MESA';
          qsErr(LANG === 'en' ? 'Code sent — check your inbox and spam.' : 'Código enviado — revisa tu correo y spam.', true);
        } catch (ex) { btn.textContent = label; qsErr(ex.message); }
        return;
      }
      const code = $e('en-li-code').value.trim();
      if (!/^\d{6}$/.test(code)) return qsErr(LANG === 'en' ? 'Enter the 6-digit code.' : 'Escribe el código de 6 dígitos.');
      try {
        btn.textContent = LANG === 'en' ? 'ENTERING…' : 'ENTRANDO…';
        const res = await api('/api/quick/verify', { name, email, code });
        await adoptSession(res);
        location.reload();
      } catch (ex) { btn.textContent = label; qsErr(ex.message); }
    };
  }
}


/** A real sale lands in the local ledger and, when online, in the server ledger too. */
export function recordSale(item, usd, method, pay) {
  ADMIN_DB.sales.unshift({ item, usd, method, pay: pay || null, buyer: ACCOUNT.fullname || PROFILE.name || L('Jugador', 'Player'), email: ACCOUNT.email || '', ts: Date.now(), demo: false });
  saveAdminDB();
  if (ONLINE_MODE && API_TOKEN) api('/api/sale', { item, usd, method, pay }).catch(() => {});
}

/* Deep-link invite: a friend shared  <origin>/?join=CODE  — prefill the mesa
   code so they just type their name and hit UNIRSE (they sit across = partner). */
export function initInviteLink() {
  try {
    const invite = new URLSearchParams(location.search).get('join');
    if (invite) {
      const gate = document.createElement('div');
      gate.id = 'invite-gate';
      gate.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(4,8,20,.92);display:flex;align-items:center;justify-content:center;padding:20px';
      gate.innerHTML = `<div style="max-width:360px;text-align:center;color:#fff">
        <div style="font-size:44px">🎲</div>
        <h2 style="margin:8px 0;color:#f0c24b">Bienvenido a MI DOMINÓ</h2>
        <p style="opacity:.9">El juego interactivo de mesa en tiempo real.</p>
        <p style="opacity:.75;font-size:14px">Welcome to MI DOMINÓ, the real-time interactive domino table.</p>
        <p style="margin-top:14px">Pulsa <b>Permitir</b> para ver y escuchar a tus amigos y jugadores.<br><span style="opacity:.8;font-size:14px">Tap <b>Allow</b> to see and hear your friends and players.</span></p>
        <button id="invite-allow" style="margin-top:14px;padding:14px 22px;border-radius:12px;border:0;background:#f0c24b;color:#1a1200;font-weight:800;font-size:17px;cursor:pointer;width:100%">📷 Permitir cámara y micrófono / Allow camera &amp; mic</button>
        <button id="invite-skip" style="margin-top:10px;background:none;border:0;color:#aab;text-decoration:underline;cursor:pointer">Ahora no / Not now</button>
      </div>`;
      document.body.appendChild(gate);
      const closeGate = () => gate.remove();
      document.getElementById('invite-skip').onclick = closeGate;
      document.getElementById('invite-allow').onclick = async () => {
        try {
          const st = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
          st.getTracks().forEach((t) => t.stop());
        } catch (e) { /* denied: they can still play; the camera button asks again */ }
        closeGate();
      };
      const code = invite.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
      // remembered so that ANY join button (quick match too) seats the friend at THIS table
      (window as any).__inviteCode = code;
      setTimeout(() => {
        const ci = document.getElementById('lobby-code');
        if (ci) { ci.value = code; }
        const on = document.getElementById('online-sec');
        if (on) on.style.outline = '2px solid var(--gold)';
        banner(L(`🔗 Te invitaron a la mesa ${code} — pon tu nombre y pulsa UNIRSE`, `🔗 You were invited to table ${code} — enter your name and hit JOIN`));
      }, 700);
    }
  } catch (e) {}
}
